import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getKeycloakRealm } from "@/components/helpers";

interface TenantApiKeyResponse {
  key: string;
}

export const useGetTenantApiKey = (enabled: boolean = false) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const tenantRealm = getKeycloakRealm;

  const getTenantApiKey = async (): Promise<TenantApiKeyResponse> => {
    try {
      const { data } = await axios.get<TenantApiKeyResponse>("/api/tenantsetting/api-key");
      return data;
    } catch (error) {
      throw new Error(t("messages.error.getTenantSettings"));
    }
  };

  return useQuery({
    queryKey: ["tenantApiKey", tenantRealm],
    queryFn: getTenantApiKey,
    enabled: enabled && Boolean(tenantRealm),
    staleTime: Infinity,
  });
};
